import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab, Typography, Paper } from '@mui/material';
import { Description, People, QrCode } from '@mui/icons-material';
import CheckinForm from './OFILeadCap.jsx';
import AttendeeList from './OFIAttendee.jsx';
import QRCodeComponent from './QRcode.jsx';
import { useLocation } from 'react-router-dom';
 import { getCurrentConfig } from '../../config/config';

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          {children}
        </Box>
      )}
    </div>
  );
};

const OFITopTabs = () => {
  const location = useLocation(); 
  const selectOFI = location.state?.selectedOpenhome;
  const selectAttendee = location.state?.attendeeDetails;
  const initialTab = location.state?.activeTab ?? 0;
  const isEditing = location.state?.isEditing ?? false; 
  const [value, setValue] = useState(initialTab);
  const config = getCurrentConfig();

  useEffect(() => {
    const newTab = location.state?.activeTab ?? 0;
    setValue(newTab);
  }, [location]); 

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', maxWidth: 1200, mx: 'auto', p: 2 }}>
     <Box sx={{ position: 'relative', mb: 2 }}>
                    <img
                      src={selectOFI?.propertyPhoto || config.noListingImage}
                      alt="Property"
                      style={{ width: '100%', height: 200, objectFit: 'cover' }}
                    />
                    <Typography
                      variant="h5"
                      sx={{
                        position: 'absolute',
                        bottom: 10,
                        left: 16,
                        color: 'white',
                        fontWeight: 'bold',
                        textShadow: '1px 1px 10px rgba(0, 0, 0, 0.7)',
                      }}
                    >
                      {selectOFI?.streetNumber} {selectOFI?.streetName} , {selectOFI?.suburb}
                    </Typography>
        </Box>
      <Paper elevation={1}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="OFI tabs"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab 
            icon={<Description />} 
            label="" 
            id="0"
            aria-controls="tabpanel-0"
          />
          <Tab 
            icon={<People />} 
            label="" 
            id="1"
            aria-controls="tabpanel-1"
          />
          <Tab 
            icon={<QrCode />} 
            label="" 
            id="2"
            aria-controls="tabpanel-2"
          />
        </Tabs>

        <TabPanel value={value} index={0}>
          <CheckinForm selectedOpenhome={selectOFI} attendeeDetails={isEditing ? selectAttendee : null}/>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <AttendeeList selectedOpenhome={selectOFI}/>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <QRCodeComponent selectedOpenhome={selectOFI} />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default OFITopTabs;